import script from "./PopUpDownloadMotionBank.vue?vue&type=script&setup=true&lang=js"
export * from "./PopUpDownloadMotionBank.vue?vue&type=script&setup=true&lang=js"

import "./PopUpDownloadMotionBank.vue?vue&type=style&index=0&id=b34aff64&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b34aff64"]])

export default __exports__